<template>
  <Head>
    <title>ЖК Сенсация» - официальный сайт проекта</title>
    <meta
      name="description"
      content="Динамичный квартал комфорт-класса в уникальной локации Читы от ГК Основа."
    />
    <meta
      property="og:title"
      content="ЖК Сенсация» - официальный сайт проекта"
    />
    <meta
      property="og:description"
      content="Динамичный квартал комфорт-класса в уникальной локации Читы от ГК Основа."
    />
  </Head>
  <main class="main my-0">
    <HomeHero />
    <HomeLifestyle id="about"/>
    <HomeQuestions />
    <HomeCoffee />
    <HomeInside class="pb-0" id="advantages"/>
    <HomeBuilding />
    <HomeParks />
    <HomeGallery id="gallery"/>
    <HomeEnvironment id="environment"/>
    <HomePlans />
    <HomePurchase id="purchase"/>
    <HomeConstruction id="building" />
    <HomeContacts id="contacts" />
    <HomeCompanyProject />
  </main>
</template>

<script>
import HomeHero from "@/components/home/Hero.vue";
import HomeLifestyle from "@/components/home/Lifestyle.vue";
// import HomeFamily from "@/components/home/Family.vue";
import HomeQuestions from "@/components/home/Questions.vue";
import HomeCoffee from "@/components/home/Coffee.vue";
import HomeInside from "@/components/home/Inside.vue";
import HomeBuilding from "@/components/home/Building.vue";
import HomeParks from "@/components/home/Parks.vue";
import HomeGallery from "@/components/home/Gallery.vue";
import HomeEnvironment from "@/components/home/Environment.vue";
// import HomeFlatsPlans from "@/components/home/FlatsPlans.vue";
import HomePlans from "@/components/home/Plans.vue";
import HomePurchase from "@/components/home/Purchase.vue";
import HomeConstruction from "@/components/home/Construction.vue";
import HomeContacts from "@/components/home/Contacts.vue";
import HomeCompanyProject from "@/components/home/CompanyProject.vue";

import { Head } from "@vueuse/head";

export default {
  components: {
    Head,
    HomeHero,
    HomeLifestyle,
    // HomeFamily,
    HomeQuestions,
    HomeCoffee,
    HomeInside,
    HomeBuilding,
    HomeParks,
    HomeGallery,
    HomeEnvironment,
    // HomeFlatsPlans,
    HomePlans,
    HomePurchase,
    HomeConstruction,
    HomeContacts,
    HomeCompanyProject,
  },
  data() {
    return {
      numPopup: 0,
      popups: [
        // {
        //   component: "PopupPromoVideo",
        //   bind: {
        //     title: `СКОРО!`,
        //     desc: `Старт продаж новых корпусов`,
        //     additionClass: "start-sales-popup",
        //     img: {
        //       default: require("@/assets/i/banners/start-sales-popup/mob-img.jpg"),
        //       sources: [
        //         {
        //           src: require("@/assets/i/banners/start-sales-popup/desk-img.webp"),
        //           media: "(min-width: 991px)",
        //         },
        //         {
        //           src: require("@/assets/i/banners/start-sales-popup/desk-img.jpg"),
        //           media: "(min-width: 991px)",
        //         },
        //         {
        //           src: require("@/assets/i/banners/start-sales-popup/mob-img.webp"),
        //           media: "(min-width: 0)",
        //         },
        //       ],
        //     },
        //     isDefault: true,
        //   },
        // },
        // {
        //   component: "PopupPromoVideo",
        //   bind: {
        //     title: `Скидки до 10%`,
        //     desc: `на квартиры в новом корпусе`,
        //     text: `Выгода до <span>896 000 ₽!</span>`,
        //     additionClass: "sales-popup",
        //     img: {
        //       default: require("@/assets/i/banners/sales-popup/mob-img.jpg"),
        //       sources: [
        //         {
        //           src: require("@/assets/i/banners/sales-popup/desk-img.webp"),
        //           media: "(min-width: 991px)",
        //         },
        //         {
        //           src: require("@/assets/i/banners/sales-popup/desk-img.jpg"),
        //           media: "(min-width: 991px)",
        //         },
        //         {
        //           src: require("@/assets/i/banners/sales-popup/mob-img.webp"),
        //           media: "(min-width: 0)",
        //         },
        //       ],
        //     },
        //     isDefault: true,
        //   },
        // },
        // {
        //   component: "PopupPromoVideo",
        //   bind: {
        //     title: `Летняя скидка`,
        //     desc: `до 7% на все лоты!`,
        //     text: `Подробности <span>в отделе продаж</span>`,
        //     additionClass: "summer-sales-popup",
        //     img: {
        //       default: require("@/assets/i/banners/summer-sales-popup/umbrella-mob-img.jpg"),
        //       sources: [
        //         {
        //           src: require("@/assets/i/banners/summer-sales-popup/umbrella-desk-img.webp"),
        //           media: "(min-width: 991px)",
        //         },
        //         {
        //           src: require("@/assets/i/banners/summer-sales-popup/umbrella-desk-img.jpg"),
        //           media: "(min-width: 991px)",
        //         },
        //         {
        //           src: require("@/assets/i/banners/summer-sales-popup/umbrella-mob-img.webp"),
        //           media: "(min-width: 0)",
        //         },
        //       ],
        //     },
        //     isDefault: true,
        //   },
        // },
        // {
        //   component: "PopupPromoVideo",
        //   bind: {
        //     title: `Дополнительная`,
        //     desc: `скидка 2%`,
        //     text: `При заключении сделки <br> в сентябре`,
        //     additionClass: "autumn-sales-popup",
        //     img: {
        //       default: require("@/assets/i/banners/autumn-sales-popup/umbrella-mob-img.jpg"),
        //       sources: [
        //         {
        //           src: require("@/assets/i/banners/autumn-sales-popup/umbrella-desk-img.webp"),
        //           media: "(min-width: 991px)",
        //         },
        //         {
        //           src: require("@/assets/i/banners/autumn-sales-popup/umbrella-desk-img.jpg"),
        //           media: "(min-width: 991px)",
        //         },
        //         {
        //           src: require("@/assets/i/banners/autumn-sales-popup/umbrella-mob-img.webp"),
        //           media: "(min-width: 0)",
        //         },
        //       ],
        //     },
        //     isDefault: true,
        //   },
        // },
      ],
    };
  },
  mounted() {
    window.addEventListener("load", () => {
      this.initNumPopup();
      this.$vfm.show(this.popups[this.numPopup]);
    });
  },
  methods: {
    initNumPopup() {
      if (!localStorage.getItem("numPopup")) {
        localStorage.setItem("numPopup", "0");
        this.numPopup = 0;
        return;
      }

      this.numPopup = JSON.parse(localStorage.getItem("numPopup"));

      if (this.numPopup < this.popups.length - 1) {
        this.numPopup = this.numPopup + 1;
        localStorage.setItem("numPopup", JSON.stringify(this.numPopup));
      } else {
        localStorage.setItem("numPopup", "0");
        this.numPopup = 0;
      }
    },
  },
};
</script>

<style>
.custom-popup .custom-popup__title {
  font-weight: 700;
  font-size: 29px;
  font-family: "Mabry", "Helvetica Neue", "Helvetica", Arial, sans-serif;
  text-transform: uppercase;
}

.custom-popup .popup-promo-video__content {
  padding: 20px !important;
}

.custom-popup .custom-popup__subtitle {
  font-weight: 500;
  font-size: 22px;
  font-family: "Mabry", "Helvetica Neue", "Helvetica", Arial, sans-serif;
  /* font-size: 32px; */
  text-transform: uppercase;
}

.custom-popup .popup-promo-video__button button {
  border-color: #fff !important;
  background-color: #fff !important;
  color: #ed1c24 !important;
}

.custom-popup .popup-promo-video__button button:hover {
  border-color: #ddd !important;
  background-color: #ddd !important;
  color: #ed1c24 !important;
}

/* .start-sales-popup {
  .popup-promo-video__title {
    font-size: 80px !important;
    font-weight: 700 !important;
    line-height: 110% !important;
    text-transform: uppercase !important;
    margin-bottom: 32px !important;
    color: #ff0020 !important;

    @media (max-width: 991px) {
      font-size: 60px !important;
      margin-bottom: 25px !important;
    }
  }

  .popup-promo-video__desc {
    font-size: 26px !important;
    font-weight: 500 !important;
    line-height: 110% !important;
    margin-bottom: 40px !important;
    color: #012A22;

    @media (max-width: 991px) {
      font-size: 20px !important;
      margin-bottom: 30px !important;
      max-width: 100% !important;
    }
  }

  .popup-promo-video__content {
    padding: 122.5px 40px !important;

    @media (max-width: 991px) {
      padding: 20px !important;
    }
  }

  .popup-promo-video__button {
    margin-top: 0 !important;
  }

  .popup-promo-video__button .btn {
    width: 186px !important;
    height: 58px !important;
    font-size: 16px !important;

    @media (max-width: 991px) {
      width: 100% !important;
    }
  }
} */

/* .sales-popup {
  .popup-promo-video__title {
    font-size: 50px !important;
    font-weight: 700 !important;
    line-height: 120% !important;
    text-transform: uppercase !important;
    margin-bottom: 2px !important;
    color: #ff0020 !important;

    @media (max-width: 991px) {
      font-size: 36px !important;
      margin-bottom: 2px !important;
    }
  }

  .popup-promo-video__desc {
    font-size: 26px !important;
    font-weight: 500 !important;
    line-height: 110% !important;
    margin-bottom: 40px !important;
    color: #545863;

    @media (max-width: 991px) {
      font-size: 18px !important;
      margin-bottom: 30px !important;
      max-width: 100% !important;
    }
  }

  .popup-promo-video__text {
    font-size: 26px !important;
    font-weight: 500 !important;
    line-height: 110% !important;
    margin-bottom: 40px !important;
    color: #545863 !important;

    span {
      color: #ff0020;
    }

    @media (max-width: 991px) {
      font-size: 18px !important;
      margin-bottom: 30px !important;
      max-width: 100% !important;
    }
  }

  .popup-promo-video__content {
    padding: 117px 40px !important;

    @media (max-width: 991px) {
      padding: 20px !important;
    }
  }

  .popup-promo-video__button {
    margin-top: 0 !important;
  }

  .popup-promo-video__button .btn {
    width: 186px !important;
    height: 58px !important;
    font-size: 16px !important;

    @media (max-width: 991px) {
      width: 100% !important;
    }
  }
} */
/* .summer-sales-popup.popup-promo-video__body {

  background-color: #FF0020 !important;

  .popup-promo-video__content {
    padding: 104px 40px;

    @media (max-width: 991px) {
      padding: 20px;
    }
  }

  .popup-promo-video__title {
    font-size: 48px;
    font-weight: 700;
    line-height: 120%;
    text-transform: uppercase;
    margin-bottom: 2px;
    color: #FFFFFF;

    @media (max-width: 991px) {
      font-size: 36px;
      margin-bottom: 2px;
    }
  }

  .popup-promo-video__desc {
    font-size: 38px;
    font-weight: 700;
    line-height: 120%;
    margin-bottom: 40px;
    text-transform: uppercase;
    color: #FFFFFF;

    @media (max-width: 991px) {
      font-size: 28px;
      max-width: 100%;
      margin-bottom: 30px;
    }
  }

  .popup-promo-video__text {
    font-size: 26px;
    font-weight: 500;
    line-height: 110%;
    margin-bottom: 40px;
    color: #FFFFFF;

    span {
      color: #FFFFFFCC;
    }

    @media (max-width: 991px) {
      font-size: 18px;
      margin-bottom: 30px;
      max-width: 100%;
    }
  }

  .popup-promo-video__button {
    margin-top: 0;
  }

  .popup-promo-video__button .btn-default{
    background: linear-gradient(105.18deg, #D3D0FF 0%, #FFFFFF 100%);
    color: #FF0020 !important;
  }

  .popup-promo-video__button .btn {
    width: 186px;
    height: 58px;
    font-size: 16px;

    @media (max-width: 991px) {
      width: 100%;
    }
  }
  .vfm__close img{
    filter: brightness(0) invert(1);
  }
} */


.autumn-sales-popup.popup-promo-video__body {
  .popup-promo-video__content {
    padding: 101px 40px;

    @media (max-width: 991px) {
      padding: 20px;
    }
  }

  .popup-promo-video__title {
    font-size: 42px;
    font-weight: 700;
    line-height: 120%;
    text-transform: uppercase;
    margin-bottom: 2px;
    color: #FF0020;

    @media (max-width: 991px) {
      font-size: 30px !important;
      margin-bottom: 2px;
    }
  }

  .popup-promo-video__desc {
    font-size: 42px;
    font-weight: 700;
    line-height: 120%;
    margin-bottom: 20px;
    text-transform: uppercase;
    color: #FF0020;

    @media (max-width: 991px) {
      font-size: 30px;
      max-width: 100%;
      margin-bottom: 15px;
    }
  }

  .popup-promo-video__text {
    font-size: 26px;
    font-weight: 500;
    line-height: 110%;
    margin-bottom: 40px;
    color: #FF0020;

    @media (max-width: 991px) {
      font-size: 18px;
      margin-bottom: 30px;
      max-width: 100%;
    }
  }

  .popup-promo-video__button {
    margin-top: 0;
  }

  .popup-promo-video__button .btn {
    width: 186px;
    height: 58px;
    font-size: 16px;

    @media (max-width: 991px) {
      width: 100%;
    }
  }
}
</style>
